import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=5e0334d8&scoped=true&"
import script from "./ShareButtons.vue?vue&type=script&lang=ts&"
export * from "./ShareButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=5e0334d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0334d8",
  null
  
)

export default component.exports